import React from 'react';
import { FlowStep } from '../FlowStep';

export class GraphNode {
  constructor(
    { exclude, id, path, prerequisite },
    flowConfig,
    { country, region, showDetails, widgetType, getBackendUrlByRegion },
  ) {
    this.data = {
      label: (
        <FlowStep
          country={country}
          flowConfig={flowConfig}
          id={id}
          path={path}
          prerequisite={prerequisite}
          region={region}
          showDetails={showDetails}
          showOpenWidgetButton={!exclude}
          widgetType={widgetType}
          getBackendUrlByRegion={getBackendUrlByRegion}
        />
      ),
    };
    this.connectable = false;
    this.id = path;
    // initial position, will be overwritten later by getLayoutedElements
    this.position = { x: 0, y: 0 };
    this.style = {
      background: exclude ? 'none' : '#D6D5E6',
      color: '#333',
      border: `1px ${exclude ? 'dashed' : 'solid'} #222138`,
      opacity: exclude ? 0.5 : 1,
    };
  }
}
